import React from 'react';

import {OBJECTS_CREATABLE_PERMISSION} from 'auth/PermissionConstants';
import {SequenceSubtype} from 'constants/ModelTypeConstants';
import {TagSchema} from 'constants/RegistryConstants';
import TagSchemaSelector from 'schemas/shared/TagSchemaSelector';
import {oligoAwareFolderItemTypeForFileType} from 'tag-schema/util/TagSchemaUtil';
import {canRemoveTagSchema} from 'tag-schema/util/TagSchemaUtil';

import {MetadataTableHeaderReadonlyContent} from './MetadataTableHeader';

function FadedMessage(props: {text: string}): JSX.Element {
  return <div className="u-tiny-spacing-top u-faded">{props.text}</div>;
}

interface PresentationalSchemaSelectorProps {
  sequenceSubtype?: SequenceSubtype;
  fileType: string;
  isDisabled: boolean;
  isFileRegistered: boolean;
  messageText?: string | null;
  onUpdateTagSchema: (tagSchema: TagSchema | null) => void;
  tagSchema: TagSchema | null;
}

function PresentationalSchemaSelector(props: PresentationalSchemaSelectorProps): JSX.Element {
  return (
    <div className="metadata-tagSchemaSelectorContainer">
      <TagSchemaSelector
        allowNone={canRemoveTagSchema(props.fileType, props.isFileRegistered)}
        oligoAwareFolderItemTypes={[
          oligoAwareFolderItemTypeForFileType(props.fileType, props.sequenceSubtype),
        ]}
        requiredPermissions={[OBJECTS_CREATABLE_PERMISSION]}
        onChange={props.onUpdateTagSchema}
        selectedTagSchemaId={props.tagSchema && props.tagSchema.id}
        forceVisibleSelectedTagSchema={props.tagSchema}
        isDisabled={props.isDisabled}
      />
      {props.messageText && <FadedMessage text={props.messageText} />}
    </div>
  );
}

export interface SchemaTagTableSchemaSelectorProps {
  isSchemaEditable: boolean;
  sequenceSubtype?: SequenceSubtype;
  fileType: string;
  isFileRegistered: boolean;
  onUpdateTagSchema: (tagSchema: TagSchema | null) => void;
  tagSchema: TagSchema | null;
}

export default function SchemaTagTableSchemaSelector(props: SchemaTagTableSchemaSelectorProps): JSX.Element {
  if (props.isSchemaEditable) {
    return (
      <PresentationalSchemaSelector
        sequenceSubtype={props.sequenceSubtype}
        fileType={props.fileType}
        isDisabled={props.isFileRegistered}
        isFileRegistered={props.isFileRegistered}
        messageText={props.isFileRegistered ? 'Cannot change schema of registered entities' : null}
        onUpdateTagSchema={props.onUpdateTagSchema}
        tagSchema={props.tagSchema}
      />
    );
  } else {
    return (
      <MetadataTableHeaderReadonlyContent
        text={props.tagSchema ? props.tagSchema.name : 'No registry schema.'}
      />
    );
  }
}
